/* eslint-disable camelcase */
import {AudioManager} from './AudioManager';
import {CreatureManager} from './CreatureManager';
import {IRWN} from './IRWN';

const AssetLoader = {


  // Models
  modelAssets: {},
  modelQueue: [],
  modelAssets: {},
  modelsLoaded: 0,

  // Textures
  textureAssets: {},
  textureQueue: [],
  textureAssets: {},
  texturesLoaded: 0,

  // Audio
  audioAssets: {},
  audioQueue: [],
  audioAssets: {},
  audioLoaded: 0,
  audioDrones: [],


  init: function(playcanvasApp) {
    this.playcanvasApp = playcanvasApp;
  },

  flushAssets: function() {
    this.flushModels();
    this.flushTextures();
    this.flushAudio();
  },
  flushModels: function() {
    for (const key in this.modelAssets) {
      if (Object.hasOwnProperty.call(this.modelAssets, key)) {
        const element = this.modelAssets[key];
        // console.log(`unloading model: ${element.name}` );
        element.unload();
      }
    }
    this.modelAssets = {};
  },
  flushTextures: function() {
    for (const key in this.textureAssets) {
      if (Object.hasOwnProperty.call(this.textureAssets, key)) {
        const element = this.textureAssets[key];
        // console.log(`unloading texture: ${element.name}` );
        if (element.name != 'irwn_creatureAtlas.basis') {
          element.unload();
        }
      }
    }
    this.modelAssets = {};
  },
  flushAudio: function() {
    for (const key in this.audioAssets) {
      if (Object.hasOwnProperty.call(this.audioAssets, key)) {
        const element = this.audioAssets[key];
        // console.log(`unloading audio: ${element.name}` );
        element.unload();
      }
    }
    this.modelAssets = {};
  },

  flushQueue: function() {
    this.modelQueue = [];
    this.modelsLoaded = 0;

    this.textureQueue = [];
    this.texturesLoaded = 0;

    this.audioQueue = [];
    this.audioLoaded = 0;

    this.queueProgress = 0;
  },
  unloadPlantAssets: function() {
    this.audioDrones = [];
  },
  //------------------------------------> QUEUE
  queueModel: function(url) {
    this.modelQueue.push(url);
    // console.log(`Loader  ::  Queue_Model ::  ${url}`);
  },
  queueTexture: function(url) {
    let duplicateFound = false;

    for (const key in this.textureQueue) {
      if (Object.hasOwnProperty.call(this.textureQueue, key)) {
        const element = this.textureQueue[key];
        if (element === url) {
          duplicateFound = true;
          break;
        }
      }
    }
    if (!duplicateFound) {
      this.textureQueue.push(url);
      // console.log(`Loader  ::  Queue_Texture ::  ${url}`);
    }
  },
  queueAudio: function(url) {
    this.audioQueue.push(url);
    // console.log(`Loader  ::  Queue_Audio ::  ${url}`);
  },

  loadQueue: function(callback) {
    // destroy all mdoel assets
    for (const key in this.modelAssets) {
      if (Object.hasOwnProperty.call(this.modelAssets, key)) {
        const asset = this.modelAssets[key];
        // console.log('UNLOADING MODEL: ' + asset.name);
        asset.unload();
      }
    }

    if (this.modelQueue.length) {
      this.loadModel(0);
    } else if (this.textureQueue.length) {
      this.loadTexture(0);
    } else if (this.audioQueue.length) {
      this.loadAudio(0);
    }
    this.callback = callback;
  },

  //------------------------------------> LOAD INDIVIDUAL ASSETS
  loadModel: function(index) {
    // console.log(`Load Model: ` + index);
    this.playcanvasApp.assets.loadFromUrl(this.modelQueue[index], 'container', function(err, asset) {
      AssetLoader.onModelLoad(err, asset);
    });
  },
  loadTexture: function(index) {
    // console.log(`Load Texture: ` + index);
    this.playcanvasApp.assets.loadFromUrl(this.textureQueue[index], 'texture', function(err, asset) {
      AssetLoader.onTextureLoad(err, asset);
    });
  },
  loadAudio: function(index) {
    // console.log(`Load Audio: ` + index);
    this.playcanvasApp.assets.loadFromUrl(this.audioQueue[index], 'audio', function(err, asset) {
      AssetLoader.onAudioLoad(err, asset);
    });
  },

  //------------------------------------> HANDLERS
  onModelLoad: function(err, asset) {
    // add to asset list
    this.modelAssets[asset.name.slice(0, -4)] = asset;
    this.modelsLoaded++;

    // Load all MODELS and then proceed to TEXTURES
    if (this.modelsLoaded < this.modelQueue.length) {
      this.loadModel(this.modelsLoaded);
    } else {
      this.loadTexture(0);
    }

    // update the loader progress
    this.updateProgress();
  },
  onTextureLoad: function(err, asset) {
    // add to asset list
    this.textureAssets[asset.name] = asset;
    this.texturesLoaded++;

    // Load all TEXTURES and then proceed to AUDIO
    if (this.texturesLoaded < this.textureQueue.length) {
      this.loadTexture(this.texturesLoaded);
    } else {
      if (this.audioQueue.length) {
        this.loadAudio(0);
      }
    }

    // update the loader progress
    this.updateProgress();
  },
  onAudioLoad: function(err, asset) {
    // add to asset list
    this.audioAssets[asset.name] = asset;
    this.audioLoaded++;

    // Load all TEXTURES and then proceed to AUDIO
    if (this.audioLoaded < this.audioQueue.length) {
      this.loadAudio(this.audioLoaded);
    }
    // update the loader progress
    this.updateProgress();
  },


  //------------------------------------> LOADER PROGRESS
  updateProgress: function() {
    const totalQueueSize = (this.modelQueue.length + this.textureQueue.length + this.audioQueue.length);
    const totalLoaded = (this.modelsLoaded + this.texturesLoaded + this.audioLoaded);
    this.queueProgress = totalLoaded / totalQueueSize;
    // console.log(`Loaded asset ${totalLoaded} / ${totalQueueSize} ---> ${this.queueProgress}`);

    if (this.queueProgress >= 1) {
      this.onQueueComplete();
    }
  },
  getProgress: function() {
    return this.queueProgress;
  },
  onQueueComplete: function() {
    // console.log("ALL ASSETS LOADED");
    this.callback();
  },
  clearQueueProgress: function() {
    this.queueProgress = 0;
  },

  ////////////////////////////////////////////////////////////////
  // Load plant assets from JSON
  ////////////////////////////////////////////////////////////////
  loadPlantAssets: function(plantJson, plantID, callback) {
    // empty out our existing queue data
    this.flushQueue();

    //------------------------------------> UI textures
    this.queueTexture('./tex/breatheBtnGlow.png');

    //------------------------------------> MODELS
    for (const stemKey in plantJson.plantStems) {
      if (plantJson.plantStems.hasOwnProperty.call(plantJson.plantStems, stemKey)) {
        const stem = plantJson.plantStems[stemKey];
        const stemName = stem.name;
        const url = './glb/' + plantID + '/' + stem.name + '.glb';
        this.queueModel(url);
      }
    }
    //------------------------------------> Creatures
    // console.log(plantJson.creatures);
    // plantJson.creatures.forEach(creatureName => {
    //     const url = './glb/creatures/' + creatureName + '.glb';
    //     this.queueModel(url);
    // });

    //------------------------------------> TEXTURES
    // plant materials
    const url_plantTextures = './tex/' + plantID + '/';
    // plant model textures
    plantJson.plantStems.forEach((stem) => {
      stem.materialSlots.forEach((slot) => {
        this.queueTexture(url_plantTextures + slot.textureName);
      });
    });

    // image planes (bg / fg etc)
    this.queueTexture(url_plantTextures + plantJson.imagePlanes.bg.textureName);
    this.queueTexture(url_plantTextures + plantJson.imagePlanes.horizon.textureName);

    plantJson.imagePlanes.list.forEach((img) => {
      this.queueTexture(url_plantTextures + img.textureName);
    });

    //particles
    const appJson = IRWN.getAppJson();
    this.queueTexture(appJson.particles.fg.particleName);
    this.queueTexture(appJson.particles.bg.particleName);
    this.queueTexture(appJson.particles.shake.particleName);
    if (plantID == '_6_HYPO') {
      this.queueTexture('./tex/particles/_6_HYPO_particle.basis');
    }

    // load all creatures
    CreatureManager.creatureList_fly.forEach((configObj) => {
      AssetLoader.queueModel('./glb/creatures/' + configObj.name + '.glb');
    });
    CreatureManager.creatureList_slither.forEach((configObj) => {
      AssetLoader.queueModel('./glb/creatures/' + configObj.name + '.glb');
    });

    //------------------------------------> AUDIO
    AudioManager.addSceneAudioToQueue(plantID);
    this.loadQueue(callback);
  },
};

export {AssetLoader};
